import React, { useContext, useState, useEffect, useRef } from 'react'
import Layout from '@/product/components/templates/Layout'
import CustomTable from '@/product/components/molecules/CustomTable'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import { Button } from '@mui/material'
import { mapData } from '@/product/common/components'
import { useFormik } from 'formik'
import CustomCommonContext from '@/custom/context/common/commonContext'
import CustomDialog from '@/product/components/organisms/Dialog'

import * as Yup from 'yup'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SettingCustomContext from '@/custom/context/setting/settingContext'
import SettingContext from '@/product/context/setting/settingContext'
import AlertContext from '@/product/context/alert/alertContext'
import UserCommonContext from '@/product/context/userCommon/commonContext'
import SerialNumberManage from './serialNumberManage'

const SerialNumber = () => {
    const settingcontext = useContext(SettingContext)
    const usercommoncontext = useContext(UserCommonContext)
    const SettingCustomContexts = useContext(SettingCustomContext)
    const alertContext = useContext(AlertContext)

    const { setAlert } = alertContext

    const { allLocations, getGlobalVariable } = useContext(CustomCommonContext)
    const [isLoading, setIsLoading] = useState(true)

    const {
        searchTableFetch,
        // searchTableAction,
        search_fetch_data,
    } = settingcontext
    const {
        searchGroupTable,
        group_table_data,
        searchTableAction,
        responseStatus,
        clearResponse,
    } = SettingCustomContexts
    const { getPreviousData, clearPreviousData, previous_data } =
        usercommoncontext

    const [changeStatus, setChangeStatus] = useState(false)

    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const [manage, setManage] = React.useState({
        popup: false,
        status: 'new',
        id: 0,
        record: {},
    })

    const toggleFullScreenPopup = (popup, status, id) => {
        if (popup) {
            setManage({ popup, status, id })
        } else {
            setManage({ popup, status: 'new', id: 0 })
        }
    }

    const [tableBody, setTableBody] = useState([])
    const formikSelection = useFormik({
        initialValues: {
            status: 0,
            id: 0,
            table: 'serial_number_bounds',
            where: 'year',
        },
        onSubmit: (values) => {
            values.uniqueValue = values.year
            searchTableAction(values, false, 'serial_number_bounds_delete')
        },
    })
    useEffect(() => {
        if (responseStatus) {
            if (
                responseStatus.from === 'serial_number_bounds_create' &&
                responseStatus.status === 'success'
            ) {
                toggleFullScreenPopup(false)
                searchTableFetch(formikView.values, 'serial_number_bounds')
            } else if (
                responseStatus.from === 'serial_number_bounds_delete' &&
                responseStatus.status === 'success'
            ) {
                searchTableFetch(formikView.values, 'serial_number_bounds')
                setChangeStatus(false)
            }
            clearResponse()
        }
    }, [responseStatus])

    const formikView = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            primaryTable: 'serial_number_bounds',
            orderby: 'sn.id,desc',
            filters: true,
            filters: {
                year: {
                    value: '',
                    type: 'in',
                    field: 'sn.year',
                },
                status: {
                    value: 1,
                    type: 'in',
                    field: 'sn.status',
                },
            },
        },
        onSubmit: (values) => {
            searchTableFetch(values, 'serial_number_bounds')
        },
    })

    useEffect(() => {
        if (search_fetch_data) {
            if (search_fetch_data.from === 'serial_number_bounds') {
                setTableBody(
                    search_fetch_data.records.length
                        ? search_fetch_data.records
                        : []
                )
            }
        }
    }, [search_fetch_data])

    useEffect(() => {
        searchTableFetch(formikView.values, 'serial_number_bounds')
    }, [])

    const onClickEdit = (id, secondaryID, type) => {
        if (type == 'delete') {
            formikSelection.values.id = id
            setChangeStatus(!changeStatus)
        } else {
            toggleFullScreenPopup(true, type, id)
        }
    }

    const getMultipleAction = () => {
        let actionPush = []
        actionPush.push({
            buttonType: 'edit',
            clickType: 'edit',
            onclick: onClickEdit,
            tooltipTitle: 'Edit',
        })

        actionPush.push({
            buttonType: 'delete',
            clickType: 'delete',
            onclick: onClickEdit,
            tooltipTitle: 'Delete',
        })

        return actionPush
    }
    const tableValues = [
        {
            field: 'id',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'ID',
            filterable: true,
            filterField: 'id',
        },
        {
            field: 'year',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Year',
            filterable: true,
            filterField: 'year',
        },
        {
            field: 'lower_bound',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Lower Bound',
            filterable: true,
            filterField: 'lower_bound',
        },
        {
            field: 'upper_bound',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Upper Bound',
            filterable: true,
            filterField: 'upper_bound',
        },
        {
            field: 'date_added',
            type: 'date',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Date Added',
            filterable: true,
            filterField: 'date_added',
        },
        {
            name: 'action',
            field: 'action',
            type: 'button',
            isMultiple: true,
            clickID: 'id',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Action',
            isMultiple: getMultipleAction(),
            tableShow: 1,
        },
    ]

    const onSelectMultiProducts = (data, action) => {
        formikSelection.values.action = action
        formikSelection.values.id = data
        if (
            action === 'active' ||
            action === 'deactive' ||
            action === 'delete'
        ) {
            if (action === 'delete') {
                getPreviousData({
                    page: 1,
                    limit: 20,
                    order: '',
                    orderby: '',
                    primaryTable: 'projects',
                    customTable: 'custom_projects',
                    similars: {
                        category: {
                            value: formikSelection.values.id,
                            type: 'arrayin',
                            field: 'p.location_id',
                        },
                    },
                })
            } else if (action === 'deactive') {
                setChangeStatus(true)
            } else {
                setChangeStatus(true)
            }
        }
    }

    useEffect(() => {
        if (previous_data) {
            if (previous_data.records.length) {
                setAlert('Previous records exists!', 'error')
                formikSelection.values.action = ''
                formikSelection.values.id = 0
                clearPreviousData()
            } else if (formikSelection.values.action) {
                setChangeStatus(true)
            }
        }
    }, [previous_data])

    const tableActions = []
    // tableActions.push(
    //     {
    //         label: 'Move to Active',
    //         icon: <span className="material-icons">check_circle</span>,
    //         onclick: onSelectMultiProducts,
    //         type: 'active',
    //     },
    //     {
    //         label: 'Move to Deactive',
    //         icon: <span className="material-icons">block</span>,
    //         onclick: onSelectMultiProducts,
    //         type: 'deactive',
    //     },
    //     {
    //         label: 'Delete Permanently',
    //         icon: <span className="material-icons">cancel</span>,
    //         onclick: onSelectMultiProducts,
    //         type: 'delete',
    //     }
    // )

    const searchInfo = [
        {
            label: 'Enter Year',
            placeholder: 'Enter Year',
            class: 'col-md-4 col-sm-6 col-12',
            type: '',
            name: 'year',
            filter: true,
            formik: formikView,
        },
    ]

    return (
        <Layout>
            <div className="dashboard staticPages">
                <CustomSearch searchInfo={searchInfo} formik={formikView} />
                <div className="d-flex justify-content-between align-items-center mt-4">
                    <Button
                        id="location_add"
                        variant="outlined"
                        className="btnOutlined"
                        onClick={() => toggleFullScreenPopup(true, 'new', 0)}
                    >
                        <span className="material-icons">note_add</span>Add New
                        Serial Number
                    </Button>
                </div>

                <CustomTable
                    formik={formikView.values}
                    tableBody={tableBody}
                    tableValues={tableValues}
                    tableActions={tableActions}
                    allData={search_fetch_data}
                    changeTableFunction={searchTableFetch}
                    fromVariable={'serial_number_bounds'}
                />
            </div>
            <SerialNumberManage
                record={search_fetch_data?.records}
                data={manage}
                function={toggleFullScreenPopup}
            />

            <CustomDialog
                title={'Confirm'}
                open={changeStatus}
                function={changeChangeStatus}
            >
                <h5>Are you sure you want to delete ?</h5>
                <div className="actionWrapper">
                    <Button
                        id="location_cancel"
                        onClick={() => changeChangeStatus()}
                    >
                        Cancel
                    </Button>
                    <form
                        onSubmit={formikSelection.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton
                            id="location_confirm"
                            type="submit"
                            label="Confirm"
                        />
                    </form>
                </div>
            </CustomDialog>
        </Layout>
    )
}
export default SerialNumber
